"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TResourceManager = exports.TPlugins = exports.TSongManager = exports.TStartupItem = exports.TConfigManager = exports.TDatabase = exports.TPageNavigator = exports.TNavBar = exports.TThemeManager = exports.TApplication = exports.TLogger = exports.TContainer = void 0;
exports.TContainer = Symbol("IContainer");
exports.TLogger = Symbol("ILogger");
exports.TApplication = Symbol("IApplication");
exports.TThemeManager = Symbol("IThemeManager");
exports.TNavBar = Symbol("INavBar");
exports.TPageNavigator = Symbol("IPageNavigator");
exports.TDatabase = Symbol("IDatabase");
exports.TConfigManager = Symbol("IConfigurationManager");
exports.TStartupItem = Symbol("IStartupItem");
exports.TSongManager = Symbol("ISongManager");
exports.TPlugins = Symbol("PluginBase");
exports.TResourceManager = Symbol("IResourceManager");
//# sourceMappingURL=globalSymbols.js.map